// extracted by mini-css-extract-plugin
export default {"legend":"styles_legend__Kz7vu","tipTable":"styles_tip-table__b3Cml"};